import React from "react";
import { AppBar, Toolbar, Container, Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Link, useLocation } from "react-router-dom";
import theme from "../Theme";

// Images
import cedr_logo from "../images/CEDR_logo.png";
import safepath_logo from "../images/SAFEPATH_logo.jpg";

const useStyles = makeStyles(() => ({
  link: {
    font: "Roboto",
    textDecoration: "none",
    color: "#7C7C7C",
    fontSize: "1.2rem",
    fontWeight: 550,
    marginLeft: theme.spacing(1),
    "&:hover": {
      color: "#3182BD",
      textDecoration: "underline",
    },
  },
  selectedLink: {
    font: "Roboto",
    textDecoration: "none",
    color: "#3182BD",
    fontSize: "1.2rem",
    fontWeight: 550,
    marginLeft: theme.spacing(1),
  },
}));

function NavBar() {
  const classes = useStyles(theme);
  const location = useLocation();

  return (
    <AppBar position="static" color="secondary" sx={{ marginBottom: 2 }}>
      <Grid
        container
        spacing={0}
        direction="row"
        alignItems="center"
        justifyContent="center"
        sx={{ backgroundColor: "background.secondary", boxShadow: 0 }}
      >
        <Grid item md={4}>
          <a href="http://www.cedr.eu/">
            <img alt="CEDR logo" src={cedr_logo} height="100px" />
          </a>
        </Grid>

        <Grid item md={8}>
          <Link to="/">
            <img
              alt="SAFEPATH logo"
              align="right"
              src={safepath_logo}
              height="100px"
            />
          </Link>
        </Grid>

        <Container maxWidth="lg">
          <Toolbar
            disableGutters
            sx={{
              flexDirection: "row",
              justifyContent: "space-evenly",
              flexGrow: 1,
              margin: 0,
              variant: 'dense',
            }}
          >
            <Link
              to="/"
              className={
                location.pathname === "/"
                  ? classes.selectedLink
                  : classes.link
              }
            >
              PROJECT
            </Link>
            <Link
              to="/measures"
              className={
                location.pathname.startsWith("/measure")
                  ? classes.selectedLink
                  : classes.link
              }
            >
              MEASURES
            </Link>
            <Link
              to="/explanation"
              className={
                location.pathname === "/explanation"
                  ? classes.selectedLink
                  : classes.link
              }
            >
              MEASURE CATEGORIES
            </Link>
            <Link
              to="/downloads"
              className={
                location.pathname === "/downloads"
                  ? classes.selectedLink
                  : classes.link
              }
            >
              DOWNLOADS
            </Link>
            <Link
              to="/guide"
              className={
                location.pathname === "/guide"
                  ? classes.selectedLink
                  : classes.link
              }
            >
              HOW TO USE
            </Link>
            <Link
              to="/contact"
              className={
                location.pathname === "/contact"
                  ? classes.selectedLink
                  : classes.link
              }
            >
              CONTACT
            </Link>
          </Toolbar>
        </Container>
      </Grid>
    </AppBar>
  );
}

export default NavBar;
